const DateRangeTexts = {
	defaultPlaceholder: 'Select Date',
	defaultTooltip: {
		startDate: 'Start date of the period for information to be reported.',
		endDate: 'End date of the period for information to be reported.',
	},
};

export default DateRangeTexts;
